import { Button, IconButton } from '@mui/material'
import React from 'react'
import { useSnackbar } from 'notistack';
import SummarizeIcon from '@mui/icons-material/Summarize';
import axios from 'axios'
const { REACT_APP_API_URL } = process.env;

const BotonResuemenPDF = (props) => {
    const { lote } = props

    const { enqueueSnackbar } = useSnackbar();

    const handleClickVariant = (resultado) => {
        const variant = resultado.variant
        const msg = resultado.errores || resultado.msg
        enqueueSnackbar(msg, { variant });
    };
    const obtenerpdf = async () => {
        const token = sessionStorage.getItem('%t')
        const requestOptions = {
            redirect: 'follow',
            responseType: 'blob',
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }
        try {
            await axios.get(`${REACT_APP_API_URL}/lotes/pdf?idlote=${lote}`, requestOptions)
                .then(response => {
                    const file = new Blob(
                        [response.data],
                        { type: 'application/pdf' }
                    );
                    const fileURL = URL.createObjectURL(file);
                    window.open(fileURL);
                })
        } catch (error) {
            console.error(error)
        }
    }
    if (props.detalle === true)
        return (
            <>
                <Button variant='contained' onClick={e => obtenerpdf()}><SummarizeIcon />Descargar reporte</Button>
            </>
        )
    return (
        <>
            <IconButton onClick={e => obtenerpdf()} size='small'>
                <SummarizeIcon />
            </IconButton>
        </>
    )
}
export default BotonResuemenPDF
